@if (config.selected_component_type || config.component) {
  <div class="component-events-table-component"
    [appLdsRoller]="loading_next" [style.height]="table_height">
    @if (is_tile !== true) {
      <ng-container class="row table-options" style="justify-content: space-between;">
        @if (dataSource) {
          <div class="table-filter">
            <i (click)="editComponentType(config.selected_component_type)" class="edit-inline hide-xs"
            matTooltip="Edit Component Type" style="margin-right:20px;"></i>
            <input (keyup)="applyFilter($event.target.value)" placeholder="Search component types"/>
          </div>
        }
      </ng-container>
    }
    <div #utils_bar class="row center hideonprint utils-bar">
      <div class="row justify-start table-filter">
        @if (config.search_by_name===true) {
          <div class="row center">
            <input matInput [(ngModel)]="search_by_name" placeholder="Find by name" name="search_by_name">
            <button (click)="refreshComponents()" mat-flat-button color="accent" class="search-button">
              <i class="fa fa-search"></i>
            </button>
          </div>
        }
        <utils-bar [searchByName]="config.search_by_name"
          (searchByNameValueSubmitted)="search_by_name=$event;refreshComponents();"
          [search]="config.search" (searchValueChanged)="applyFilter($event)"
          (searchValueSubmitted)="filter_string=$event;createUserFilters()"
          (searchCleared)="clearSearch()"
          [userSearchFields]="user_search_fields"
          (searchSelectionsChanged)="user_search_selections=$event"
          [sortByArray]="columns"
          >
        </utils-bar>
        @if (showCreateComponent()) {
          <button [disabled]="!canCreateComponent()"
            [matTooltip]="'Click here to create a new ' + ((component_type?.attributes?.name || 'component') | removeUnderscore | upperfirst)"
            mat-flat-button color="accent" class="search-button" matTooltip="Insert new row"
            (click)="newComponent()">
            <i class="fa fa-plus"></i>
          </button>
        }
        <filter-table-button [config]="filter_button_config"
        (queryChanged)="updateFilterQuery($event)"></filter-table-button>
      </div>
      <mat-paginator [length]="component_total" [pageSize]="page_size"
        [pageSizeOptions]="page_size_options.includes(component_total) ? page_size_options : page_size_options.concat(component_total)"
        [pageIndex]="page_index"
        showFirstLastButtons
        (page)="pageData($event)"
        [disabled]="loading_next===true">
      </mat-paginator>
    </div>
    @if (filter_warning) {
      <div class="row hideonprint warning info" style="padding: 4px;border-left: 1px solid #ccc;">
        {{filter_warning}}
      </div>
    }
    @if (config.scroll_top) {
      <div style="overflow-x: auto;overflow-y:hidden; width:100%;"
        (scroll)="mimicScrollBottom($event)">
        <div #top_scroll style="height:1px;"></div>
      </div>
    }
    <div overlay-scrollbars [defer] [options]="{scrollbars: {autoHide: 'leave'}}"
      [ngClass]="{'component-events-table-tile': is_tile===true, 'render-pdf': isRenderingPdf}"
      class="table-container" #component_events_table (scroll)="mimicScrollTop($event)"
      [attr.id]="'pdf-' + tileData.id" tabindex="1">
      <app-pdf-header [pdfHeader]="tileData.tile?.attributes?.title"></app-pdf-header>
      <table [dataSource]="dataSource"
        [matSortActive]="columns[0]"
        class="component-events-table" mat-table matSort
        matSortDirection="desc" multiTemplateDataRows="true">
        @for (column of columns; track column) {
          <!--Aggregation Header Row-->
          <ng-container matColumnDef="{{'aggregation'+column}}">
            @if (column==='name') {
              <th *matHeaderCellDef sticky class="aggregation-cell-header"
                [ngClass]="{'select-offset' : columns.includes('Select')}">Aggregation
              </th>
            }
            @if (selected_cols_dict[column]?.type!=='constant_property' && column !=='name' && column !=='changed_by_name') {
              <th *matHeaderCellDef
                [ngClass]="{'aggregation-select' : column==='Select','aggregation-expand' : column==='Expand',
                'select-offset' : column==='Expand' && columns.includes('Select'),  'hideonprint':column==='Expand'}"
                [matTooltip]="aggregation_row[column]?.aggregation">
                @if (aggregation_row[column]?.data_type==='datetime') {
                  <span>{{aggregation_row[column]?.value}}</span>
                }
                @if (aggregation_row[column]?.data_type!=='datetime' && shouldFormatAsInteger(aggregation_row[column]?.aggregation)) {
                  <span>{{aggregation_row[column]?.value|formatNumber:0}}</span>
                }
                @if (aggregation_row[column]?.data_type!=='datetime' && !shouldFormatAsInteger(aggregation_row[column]?.aggregation)) {
                  <span>{{aggregation_row[column]?.value|formatNumber:format_dict?.[column]?.decimals || 0}}</span>
                }
              </th>
            }
            @if (selected_cols_dict[column]?.type==='constant_property') {
              <th *matHeaderCellDef
                [matTooltip]="aggregation_row[column]?.aggregation">
                @if (shouldFormatAsInteger(aggregation_row[column]?.aggregation)) {
                  <span>{{aggregation_row[column]?.value|formatNumber:0}}</span>
                }
                @if (!shouldFormatAsInteger(aggregation_row[column]?.aggregation) && aggregation_row[column]?.data_type==='datetime') {
                  <span>{{aggregation_row[column]?.value}}</span>
                }
                @if (!shouldFormatAsInteger(aggregation_row[column]?.aggregation) && aggregation_row[column]?.data_type!=='datetime') {
                  <span>{{aggregation_row[column]?.value|formatNumber:format_dict?.[column]?.decimals:true:3 | thousandsSeparate}}</span>
                }
              </th>
            }
          </ng-container>
          <!--Select-->
          @if (column==='Select') {
            <ng-container (click)="$event.stopPropagation()" matColumnDef="{{column}}">
              <th *matHeaderCellDef mat-header-cell style="text-align:center;width:20px;padding-left:0;">
                <mat-checkbox (change)="selectAll($event)" (click)="$event.stopPropagation()"
                  matTooltip="Select/Clear all"
                [matTooltipShowDelay]="tooltipShowDelay"></mat-checkbox>
              </th>
              <td (click)="$event.stopPropagation()" *matCellDef="let component;" class="select-column" mat-cell
                style="text-align:center;">
                <mat-checkbox (change)="selectEvent(component, $event)"
                [checked]="rows_selection_status[component.id]"></mat-checkbox>
              </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>
          }
          <!--Expand-->
          @if (column==='Expand') {
            <ng-container (click)="$event.stopPropagation()" matColumnDef="{{column}}">
              <th *matHeaderCellDef mat-header-cell [ngClass]="{'select-offset' : columns.includes('Select')}"
                class="hideonprint">
              </th>
              <td *matCellDef="let component;" mat-cell class="hideonprint"
                [ngClass]="{'select-offset' : columns.includes('Select')}">
                <div>
                  <span (click)="editComponent(component, $event)" class="material-symbols-outlined expand"
                  matTooltip="Expand side panel">open_in_full</span>
                  <span class="material-symbols-outlined arrow" matTooltip="Expand row">
                  {{component.id == expandedElement?.id ? 'arrow_drop_down' : 'arrow_right'}}</span>
                </div>
              </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>
          }
          <!--Name-->
          @if (column==='name') {
            <ng-container matColumnDef="{{column}}">
              <th *matHeaderCellDef mat-header-cell sticky mat-sort-header [resizable]="format_dict?.[column]"
                (resizable)="resizeColumn(column, $event)" [constrainWidth]="config.constrain_width"
                [ngClass]="{'select-offset' : columns.includes('Select')}" class="outer-table-name">
                {{selected_cols_dict[column]?.title || 'name' | upperfirst | removeUnderscore}}
              </th>
              <td *matCellDef="let component;" mat-cell sticky
                class="lock-indicator attribute-field"
                [matTooltipDisabled]="!eventsService.event_state[component.id + column]"
              [matTooltip]="eventsService.event_state[component.id + column]? eventsService.event_state[component.id + column].message :
                   component.attributes.description"
              [ngClass]="[eventsService.event_state[component.id + column]? eventsService.event_state[component.id + column].state: '',
columns.includes('Select')?'select-offset':'']">
                @if (generic_constants[component.id]?.name?.locked) {
                  <i class="fa fa-lock lock-indicator-icon"
                  (click)="checkLock(component, column)" [style.cursor]="can_unlock? 'pointer':'default'"></i>
                }
                @if (config.show_audit) {
                  <audit-mixin-indicator [model]="component"></audit-mixin-indicator>
                }
                <div class="row center" style="height:100%;justify-content: space-between;"
                  [ngStyle]="formats?.[column]?.[component.id]?.style || null">
                  <div class="row center" style="width:100%;height:100%;">
                    <input matInput
                      [(ngModel)]="component.attributes.name"
                      (click)="$event.stopPropagation()"
                      (change)="saveComponent(component, column, $event);"
                      [disabled]="selected_cols_dict[column]?.disabled || generic_constants[component.id]?.name?.locked || !canEditComponent()"
                      [appFitContent]="component.attributes.name"
                      [allowFit]="format_dict?.[column]?.allow_fit"
                      style="width:auto;max-width:250px;min-width:calc(100% - 28px);"/>
                  </div>
                  <!-- PDF Printouts - printouts list fetched via pipe componentPrintouts -->
                  @if (config.printout) {
                    <button (click)="$event.stopPropagation()" [matMenuTriggerFor]="right_mat_menu2"
                      style="display: inline;min-width:unset;padding:0 10px;line-height:unset;"
                      class="user-menu combo hideonprint" mat-button>
                      <i class="fas fa-print"></i>
                    </button>
                    <mat-menu #right_mat_menu2="matMenu" backdropClass="header-menu-backdrop"
                      class="tree-node-menu">
                      <ng-template matMenuContent>
                        @if (component.id) {
                          <component-printout-menu
                            [inputComponentId]="component.id"
                          [inputPrintoutsAllowed]="config.printouts"></component-printout-menu>
                        }
                      </ng-template>
                    </mat-menu>
                  }
                  @if (config.enable_export_component?.length > 0 ) {
                    @for (export_component of config.enable_export_component; track export_component) {
                      @if (export_component.supports_row_export) {
                        <button mat-stroked-button (click)="$event.stopPropagation(); push_selected_components_to_client(
                          export_component, [component.id])" class="export-data-cell-button">
                          {{export_component.display_text}}
                        </button>
                      }
                    }
                  }
                </div>
              </td>
              <td mat-footer-cell *matFooterCellDef sticky>Aggregation</td>
            </ng-container>
          }
          @if (attribute_cols_set.has(column) && column !=='name' && !selected_cols_dict[column]?.related_type_id) {
            <ng-container matColumnDef="{{column}}">
              <th *matHeaderCellDef mat-header-cell mat-sort-header [resizable]="format_dict?.[column]"
                (resizable)="resizeColumn(column, $event)"
                [constrainWidth]="config.constrain_width">
                {{selected_cols_dict[column]?.title || selected_cols_dict[column]?.id | upperfirst | removeUnderscore}}
              </th>
              @if (column.includes('changed_by')) {
                <td *matCellDef="let component;" mat-cell class="attribute-field">
                  <div [ngStyle]="formats?.[column]?.[component.id]?.style || null">
                    <div
                      class="align">{{column === 'changed_by' ? component.attributes.changed_by_name : generic_constants[component.id][column]}}
                    </div>
                  </div>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              } @else {
                <td *matCellDef="let component;" class="attribute-field date-picker-field lock-indicator" mat-cell
                  [ngStyle]="formats?.[column]?.[component.id]?.style || null">
                  @if (generic_constants[component.id] && generic_constants[component.id][column]?.locked) {
                    <i
                      (click)="checkLock(component, column)" class="fa fa-lock lock-indicator-icon"></i>
                  }
                  @if (column.includes('start_time') && !(generic_constants[component.id]?.[column]?.data_type==='float')) {
                    <date-time-picker
                      (date_changed)="component.attributes.start_time = $event;saveComponent(component, column, $event)"
                      [default]="dtp?.start"
                      [input_date]="column==='start_time' ? component.attributes.start_time : generic_constants[component.id]?.[column]?.value"
                      [set_default]="false"
                      [disabled]="selected_cols_dict[column]?.disabled || generic_constants[component.id]?.start_time?.locked || !canEditComponent()"
                      [styles]="formats?.[column]?.[component.id]?.style || null"
                    ></date-time-picker>
                  }
                  @if (column.includes('end_time') && !(generic_constants[component.id]?.[column]?.data_type==='float')) {
                    <date-time-picker
                      (date_changed)="component.attributes.end_time = $event;saveComponent(component, column, $event)"
                      [default]="dtp?.end"
                      [input_date]="column==='end_time' ? component.attributes.end_time : generic_constants[component.id]?.[column]"
                      [set_default]="false"
                      [disabled]="selected_cols_dict[column]?.disabled || generic_constants[component.id]?.end_time?.locked || !canEditComponent()"
                      [styles]="formats?.[column]?.[component.id]?.style || null"
                    ></date-time-picker>
                  }
                  @if (generic_constants[component.id]?.[column]?.data_type==='float') {
                    <div
                      [ngStyle]="formats?.[column]?.[component.id]?.style || null"
                      style="display:inline;">{{generic_constants[component.id][column]?.value}}
                    </div>
                  }
                </td>
                <td mat-footer-cell
                  *matFooterCellDef
                  [matTooltip]="aggregation_row[column]?.aggregation">
                  @if (shouldFormatAsInteger(aggregation_row[column]?.aggregation)) {
                    <span>{{aggregation_row[column]?.value|formatNumber:0}}</span>
                  }
                  @if (!shouldFormatAsInteger(aggregation_row[column]?.aggregation)) {
                    <span>{{aggregation_row[column]?.value|formatNumber:format_dict[column]?.decimals || 0}}</span>
                  }
                </td>
              }
            </ng-container>
          }
          <!--Constant Properties-->
          @if (selected_cols_dict[column]?.type === 'constant_property' || selected_cols_dict[column]?.related_type_id) {
            <ng-container matColumnDef="{{column}}">
              <th *matHeaderCellDef mat-header-cell [resizable]="format_dict?.[column]"
                (resizable)="resizeColumn(column, $event)"
                [constrainWidth]="config.constrain_width"
                (dblclick)="getTree(column)"
                mat-sort-header>
                {{selected_cols_dict[column]?.title || cp_dict[column]?.attributes.alias || cp_dict[column]?.attributes.name | upperfirst | removeUnderscore}}
              </th>
              <td (click)="$event.stopPropagation()" *matCellDef="let component" mat-cell
                [matTooltipDisabled]="!eventsService.event_state[component.id + column]"
                [matTooltip]="eventsService.event_state[component.id + column]? eventsService.event_state[component.id + column].message : ''"
                [ngClass]="[eventsService.event_state[component.id + column]? eventsService.event_state[component.id + column].state : '',
 (cp_dict[column]?.attributes.data_type || '')]"
                style="position:relative;">
                @if (config.show_audit && auditMixinDict && auditMixinDict[component.id]
                  && auditMixinDict[component.id][column]) {
                  <audit-mixin-indicator
                    [model]="auditMixinDict[component.id][column]"></audit-mixin-indicator>
                }
                @if (generic_constants[component.id] && generic_constants[component.id].hasOwnProperty(column)
                  && (cp_dict && cp_dict.hasOwnProperty(selected_cols_dict[column]?.id) || selected_cols_dict[column]?.related_type_id || ['list','float','datetime'].includes(generic_constants[component.id][column].data_type))) {
                  <generic-component-field
                    [constant_property]="cp_dict[selected_cols_dict[column]?.id]"
                    [constant]="generic_constants[component.id][column]"
                    [component]="component"
                    [tooltip]="cp_class_dict[component.id + column]?.message"
                    [auto_class]="cp_class_dict[component.id + column]?.class"
                    [formats]="formats?.[column]?.[component.id]"
                    (relayConstantChangedEmitter)="generic_constants[component.id][column].value = $event;"
                    (relayChangeCompleteEmitter)="saveConstant(component, column, $event)"
                    [disabled]="cp_dict?.[selected_cols_dict[column]?.id]?.attributes.is_calculation || selected_cols_dict[column]?.disabled || selected_cols_dict[column]?.related_type_id || !canEditComponent()"
                    (relayLockClickedEmitter)="checkLock(component, column)"
                  ></generic-component-field>
                } @else {
                  <div class="constant-disabled"></div>
                }
              </td>
              <td mat-footer-cell *matFooterCellDef [matTooltip]="aggregation_row[column]?.aggregation">
                @if (shouldFormatAsInteger(aggregation_row[column]?.aggregation)) {
                  <span>{{aggregation_row[column]?.value|formatNumber:0}}</span>
                }
                @if (!shouldFormatAsInteger(aggregation_row[column]?.aggregation) && aggregation_row[column]?.data_type==='datetime') {
                  <span>{{aggregation_row[column]?.value}}</span>
                }
                @if (!shouldFormatAsInteger(aggregation_row[column]?.aggregation) && aggregation_row[column]?.data_type!=='datetime') {
                  <span>{{aggregation_row[column]?.value|formatNumber:format_dict[column]?.decimals:true:3 | thousandsSeparate}}</span>
                }
              </td>
            </ng-container>
          }
          <!--Component Types-->
          @if (selected_cols_dict[column]?.type === 'component_type') {
            <ng-container matColumnDef="{{column}}">
              <th *matHeaderCellDef mat-header-cell [resizable]="format_dict?.[column]"
                (resizable)="resizeColumn(column, $event)"
                [constrainWidth]="config.constrain_width"
                mat-sort-header>
                {{selected_cols_dict[column]?.title || ctDict[column]?.attributes.name | upperfirst | removeUnderscore}}
              </th>
              <td (click)="$event.stopPropagation()" *matCellDef="let component;" mat-cell class="component-type-field">
                @if (config.show_audit && auditMixinDict && auditMixinDict[component.id]
                  && auditMixinDict[component.id][column]) {
                  <audit-mixin-indicator
                    [model]="auditMixinDict[component.id][column]" [showTitle]="true"></audit-mixin-indicator>
                }
                <!-- Show count if aggregation type is 'count' -->
                @if (selected_cols_dict[column]?.format?.aggregation_type === 'count' && generic_constants[component.id]?.[column]) {
                  <div
                    [ngStyle]="formats?.[column]?.[component.id]?.style || null">
                    {{generic_constants[component.id][column]?.value || 0}}
                  </div>
                }
                <!-- Show selector if aggregation type is 'none', 'default', or undefined -->
                @if (selected_cols_dict[column]?.format?.aggregation_type !== 'count' && componentComponentDict?.[component.id]) {
                  <div
                    [ngStyle]="formats?.[column]?.[component.id]?.style || null">
                    @if (ctCtDict[column]?.isUnique) {
                      <select-search-component
                        (selectionChange)="updateComponentComponentRelationship(component, column, $event);"
                        [disabled]="selected_cols_dict[column].disabled"
                        [component_types]=[column]
                        [api_model]="'component'"
                        [compareFunctionName]="'compareById'"
                        [custom_filters]="componentComponentTypeMap.filters?.[component.id]?.[column]"
                        [allow_none]="true"
                        [sort_by]="'-created_on'"
                        [panelClasses]="'table-select-search'"
                        [skipLoad]="true"
                        [classes]="'full-width min-max-inherit table-row show-select-arrow ' + (selected_cols_dict[column]?.format?.fit_content ? 'fit-content' : '')"
                        [value]="componentComponentDict[component.id]?.[column]?.[0]">
                      </select-search-component>
                    }
                    @if (ctCtDict[column] && !ctCtDict[column].isUnique) {
                      <select-many-search-component
                        (selectionChangeComplete)="updateComponentComponentRelationship(component, column, $event);"
                        [disabled]="selected_cols_dict[column].disabled"
                        [api_model]="'component'"
                        [custom_filters]="componentComponentTypeMap.filters?.[component.id]?.[column]"
                        [custom_selected_filters]="componentComponentTypeMap.selectedFilters?.[component.id]?.[column]"
                        [compareFunctionName]="'compareById'"
                        [sort_by]="'-created_on'"
                        [classes]="'auto-width min-max-inherit table-row'"
                        [value]="componentComponentDict[component.id]?.[column]"
                        [stringFunction]="getComponentName"
                        [skipFetchName]="true"
                        >
                      </select-many-search-component>
                    }
                  </div>
                }
              </td>
              <td mat-footer-cell *matFooterCellDef
                [matTooltip]="aggregation_row[column]?.aggregation">
                @if (shouldFormatAsInteger(aggregation_row[column]?.aggregation)) {
                  <span>{{aggregation_row[column]?.value|formatNumber:0}}</span>
                }
                @if (!shouldFormatAsInteger(aggregation_row[column]?.aggregation)) {
                  <span>{{aggregation_row[column]?.value|formatNumber:format_dict?.[column]?.decimals || 0}}</span>
                }
              </td>
            </ng-container>
          }
        }
        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        <ng-container matColumnDef="expandedDetail">
          <td *matCellDef="let component" [attr.colspan]="columns.length" mat-cell>
            <div [@detailExpand]="component.id == expandedElement?.id ? 'expanded' : 'collapsed'"
              class="resource-detail">
              <div class="expand-inner-table"
                (click)="expandedEvents = expandedEvents?.id === component.id ? null : component;">
                <i class="fa"
                  [ngClass]="expandedEvents?.id === component.id ? 'fa-caret-up' : 'fa-caret-down'"></i>
                @if (expandedEvents?.id !== component.id) {
                  <span>Show</span>
                }
                @if (expandedEvents?.id === component.id) {
                  <span>Hide</span>
                } Events
              </div>
              @if (component.id === expandedElement?.id && expandedEvents?.id === component.id) {
                <div>
                  <events-table [component]="component" [config]="config"
                    [save_content]="save_content"></events-table>
                </div>
              }
              @if (true) {
                <div class="expand-inner-table"
                  (click)="expandedComponents = expandedComponents?.id === component.id ? null : component;">
                  <i class="fa"
                    [ngClass]="expandedComponents?.id === component.id ? 'fa-caret-up' : 'fa-caret-down'"></i>
                  @if (expandedComponents?.id !== component.id) {
                    <span>Show</span>
                  }
                  @if (expandedComponents?.id === component.id) {
                    <span>Hide</span>
                  } Components
                </div>
                @if (component.id === expandedElement?.id && expandedComponents?.id === component.id) {
                  <div>
                    <div style="width:100%;">
                      @for (component_type of config.selected_component_relationship_types; track component_type) {
                        <div
                          style="display:block;width:100%;margin-top:1px;">
                          <components-table [parent_component]="component"
                            [selected_component_relationship_type]="component_type"
                            [save_content]="save_content"
                            [config]="config">
                          </components-table>
                        </div>
                      }
                    </div>
                  </div>
                }
              }
            </div>
          </td>
        </ng-container>
        <!--Row defs-->
        <tr *matHeaderRowDef="columns;" sticky mat-header-row></tr>
        @if (config.show_aggregations_top && columns.length > 0 && dataSource?.data?.length) {
          <tr *matHeaderRowDef="agg_columns" mat-footer-row
            [rowResizable]="rowHeightDict?.aggregation_top_row_height"
            (rowResizable)="rowHeightDict.aggregation_top_row_height.height=$event"></tr>
        }
        <tr (click)="expandedElement = expandedElement?.id === element.id ? null : element;"
          *matRowDef="let element; columns: columns;"
          [class.component-expanded-row]="expandedElement && expandedElement.id === element.id"
          mat-row
          [rowResizable]="rowHeightDict?.row_height"
          (rowResizable)="rowHeightDict.row_height.height=$event"
          [style.height]="rowHeightDict?.row_height?.height ? rowHeightDict.row_height.height + 'px' : 'auto'"
          [style.min-height]="rowHeightDict?.row_height?.height ? rowHeightDict.row_height.height + 'px' : 'unset'">
        </tr>
        @if (config.show_aggregations && columns.length > 0 && dataSource?.data?.length) {
          <tr *matFooterRowDef="columns" mat-footer-row
            [rowResizable]="rowHeightDict?.aggregation_bottom_row_height"
            (rowResizable)="rowHeightDict.aggregation_bottom_row_height.height=$event">
          </tr>
        }
        <tr *matRowDef="let row; columns: ['expandedDetail']"
          [class.detail-not-expanded]="!expandedElement || expandedElement.id !== row.id "
          class="event-detail-row"
          mat-row
          [rowResizable]="rowHeightDict?.detail_row_height"
          (rowResizable)="rowHeightDict.detail_row_height.height=$event"
          [style.height]="getDetailRowHeight(row)"
          [style.min-height]="getDetailRowHeight(row, 'unset')"></tr>
        <!--Renders in the table body directly under the header row whenever there are no rows
            (empty result or a filter matching nothing); flows with the header height.-->
        <tr *matNoDataRow class="component-events-no-data-row">
          <td [attr.colspan]="columns.length || 1">No data to display.</td>
        </tr>
      </table>
      <app-pdf-footer></app-pdf-footer>
    </div>
  </div>
}
